import { Directive, HostBinding, Input } from '@angular/core';
import { FacebookFormLogsStatus } from 'src/app/core/models/social-forms-configurations/facebook-form-configuration.model';

@Directive({
    selector: '[appLogStatusStyle]',
    standalone: false
})
export class LogStatusStyleDirective {

  @HostBinding('class') class = ''
  @HostBinding('innerHTML') text = ''

  @Input() set status(status: FacebookFormLogsStatus) {

    console.log('status', status)
    switch (status) {
      case FacebookFormLogsStatus.DONE: this.class = 'infoSeverity'; break
      case FacebookFormLogsStatus.ERROR: this.class = 'errorSeverity'; break
      case FacebookFormLogsStatus.TODO: this.class = 'noSeverity'; break
      default: this.class = 'noSeverity'; break
    }

    switch (status) {
      case FacebookFormLogsStatus.DONE: this.text = 'Done'; break
      case FacebookFormLogsStatus.ERROR: this.text = 'Error'; break
      case FacebookFormLogsStatus.TODO: this.text = 'Todo'; break
      default: this.text = 'aaa'; break
    }
  }

  constructor() { }

}
